import * as tslib_1 from "tslib";
import createAttachments from 'owa-mail-compose-store/lib/utils/createAttachments';
export default function createAttachmentHandler(files, inlineImagePlugin, viewState, shouldShare, isInline) {
    if (shouldShare === void 0) { shouldShare = false; }
    if (isInline === void 0) { isInline = false; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var isPlainText, processInlineImageBeforeUpload;
        return tslib_1.__generator(this, function (_a) {
            isPlainText = viewState.bodyType != 'HTML';
            processInlineImageBeforeUpload = isPlainText
                ? null
                : inlineImagePlugin.processInlineImageBeforeUpload.bind(inlineImagePlugin);
            createAttachments(files, isInline, viewState, shouldShare, false /* isHiddenInline */, processInlineImageBeforeUpload);
            return [2 /*return*/];
        });
    });
}
//# sourceMappingURL=createAttachmentHandler.js.map